// extracted by mini-css-extract-plugin
export default {"search_jobs_page":"SearchJobs_search_jobs_page__6mHuq","success_container":"SearchJobs_success_container__v-szS","jobs_grid":"SearchJobs_jobs_grid__qIes4"};